import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  Flex,
  Box,
  Text,
  Link as ChakraLink,
  Portal,
  useOutsideClick,
} from "@chakra-ui/react";

import { copyTextToClipboard } from "@/utils/copyToClipboard";
import { getTenantConfig } from "@/config/tenantConfig";
import { Tabs } from "@/components";
import { Alert } from "@/components";
import { WithAuth } from "@/hoc";
import { useCustomLink } from "@/hooks";
import { PaymentLinkData, CustomLinkPaginator } from "@/models";
import { formatCurrency, formatDate, showToast } from "@/utils";
import { DynamicTable } from "@/components/DynamicTable";
import { PageHeading, Checkbox, DrawerList, ActionDrawerItems, Icon, IconButton } from "barte-design-system";
import { DotsThreeVerticalIcon, CopyIcon, FilesIcon, TrashIcon, LinkIcon, ArrowSquareOutIcon } from "@phosphor-icons/react";
const CustomLinks = () => {
  const { getCustomLink, handleDeleteCustomLink } = useCustomLink();
  const navigate = useNavigate();
  const [data, setData] = useState({} as CustomLinkPaginator);
  const cancelRef = useRef();
  const [actualTab, setActualTab] = useState("orders");
  const [userUuid, setUserUuid] = useState<PaymentLinkData>();
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [duplicateModalState, setDuplicateModalState] = useState(false);
  const [clientButtonState, setClientButtonState] = useState(false);
  const [filterPlaceholder, setFilterPlaceholder] = useState(
    "Buscar cobranças pontuais"
  );
  const [currentPage, setCurrentPage] = useState(0);
  const user = JSON.parse(localStorage.getItem("barte-user-info"));
  const [tabs, setTabs] = useState([])
  const [isCreateMenuOpen, setIsCreateMenuOpen] = useState(false);
  const createMenuRef = useRef<HTMLDivElement>(null);
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);
  const [menuPosition, setMenuPosition] = useState<{ top: number; right: number } | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRefs = useRef<Map<string, HTMLButtonElement>>(new Map());
  const [pageSize, setPageSize] = useState(8);


  async function getCustomLinkData(filter?: string) {

    let isDefaultApp = location?.hostname?.includes('barte.com');
    let filter_params = { size: pageSize, page: currentPage, sort: "createdAt,DESC", whiteLabel: !isDefaultApp };

    try {
      const response = await getCustomLink(
        actualTab,
        {
          [actualTab.includes("orders") ? "title" : "planTitle"]: filter
            ? filter
            : "",
        },
        filter_params
      );
      // setFilteredData(response.data);
      setData(response.data);
    } catch (error) {
      error?.response?.data?.errors.map((error) => {
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`,
        });
      });
    }
  }

  let initialTabs = [];

  const newColums = [
    {
      key: actualTab.includes("orders") ? "title" : "planTitle",
      title: actualTab.includes("orders") ? "Título" : "Plano",
      dataIndex: actualTab.includes("orders") ? "title" : "planTitle",
      render: (text, record) => (
        <Text>
          {text}
        </Text>
      )
    },

    {
      key: "createdAt",
      title: "Criado em",
      dataIndex: "createdAt",
      render: (createDate) => formatDate(createDate),
    },

    {
      key: actualTab.includes("orders") ? "value" : "valuePerMonth",
      title: "Valor",
      dataIndex: actualTab.includes("orders") ? "value" : "valuePerMonth",
      render: (value) => (value == null ? "Valor definido pelo cliente" : formatCurrency({ value })),
    },
    {
      key: "name",
      title: "Cliente",
      dataIndex: "sellerClient",
      render: (text, record) => (
        <Flex align="center" gridGap="2">
          <Text color={record?.sellerClient?.name ? "black" : "gray.300"}>
            {record?.sellerClient?.name
              ? record?.sellerClient?.name
              : "Sem cliente"}
          </Text>
        </Flex>
      ),
    },
    {
      key: "actions",
      title: "",
      dataIndex: "uuid",
      align: "right" as const,
      render: (text, record) => (
        <Box position="relative"
          onClick={(e) => e.stopPropagation()}
        >
          <IconButton
            ref={(el) => {
              if (el) {
                buttonRefs.current.set(record.uuid, el);
              } else {
                buttonRefs.current.delete(record.uuid);
              }
            }}
            variant="outline"
            size="sm"
            round="soft"
            aria-label="Actions"
            onClick={(e) => {
              e.stopPropagation();
              const button = buttonRefs.current.get(record.uuid);
              if (button) {
                const rect = button.getBoundingClientRect();
                setMenuPosition({
                  top: rect.top + window.scrollY,
                  right: window.innerWidth - rect.left + 8
                });
              }
              setOpenMenuId(openMenuId === record.uuid ? null : record.uuid);
            }}
          >
            <DotsThreeVerticalIcon weight="bold" />
          </IconButton>
          {openMenuId === record.uuid && record && menuPosition && (
            <Portal>
              <Box
                position="fixed"
                top={`${menuPosition.top}px`}
                right={`${menuPosition.right}px`}
                zIndex={1000}
                ref={menuRef}
                onClick={(e) => e.stopPropagation()}
              >
                <DrawerList>
                  <ActionDrawerItems title="" items={[
                    {
                      label: 'Copiar ID',
                      variant: 'icon' as const,
                      icon: <Icon icon={CopyIcon} size={16} />,
                      onClick: () => {
                        setOpenMenuId(null);
                        setMenuPosition(null);
                        navigator.clipboard.writeText(record.uuid)
                          .then(() => {
                            showToast({
                              type: "success",
                              message: "ID copiado para a área de transferência.",
                            });
                          })
                          .catch((err) => {
                            console.error("Erro ao copiar UUID:", err);
                          });
                      }
                    },
                    ...(actualTab !== "subscriptions" ? [{
                      label: 'Duplicar link',
                      variant: 'icon' as const,
                      icon: <Icon icon={FilesIcon} size={16} />,
                      onClick: () => {
                        setOpenMenuId(null);
                        setMenuPosition(null);
                        setUserUuid({
                          ...userUuid,
                          uuid: record.uuid,
                        });
                        setDuplicateModalState(!duplicateModalState);
                      }
                    }] : []),
                    {
                      label: 'Copiar Link',
                      variant: 'icon' as const,
                      icon: <Icon icon={LinkIcon} size={16} />,
                      onClick: () => {
                        setOpenMenuId(null);
                        setMenuPosition(null);
                        if (actualTab.includes("subscriptions")) {
                          copyTextToClipboard(`${getTenantConfig().checkoutUrl}payment-link/${record.uuid}`)
                        } else {
                          copyTextToClipboard(`${getTenantConfig().checkoutUrlV2}payment-link/${record.uuid}`)
                        }
                      }
                    },
                    {
                      label: 'Abrir em nova aba',
                      variant: 'icon' as const,
                      icon: <Icon icon={ArrowSquareOutIcon} size={16} />,
                      onClick: () => {
                        setOpenMenuId(null);
                        setMenuPosition(null);
                        window.open(`/seja-pago/editar/${record.uuid}`, '_blank');
                      }
                    },
                    {
                      label: 'Deletar',
                      variant: 'icon' as const,
                      icon: <Icon icon={TrashIcon} size={16} />,
                      onClick: () => {
                        setOpenMenuId(null);
                        setMenuPosition(null);
                        setUserUuid({
                          ...userUuid,
                          uuid: record.uuid,
                        });
                        setDeleteModalState(!deleteModalState);
                      }
                    }
                  ]} />
                </DrawerList>
              </Box>
            </Portal>
          )}
        </Box>
      ),
    },
  ];

  useOutsideClick({
    ref: menuRef,
    handler: () => {
      setOpenMenuId(null);
      setMenuPosition(null);
    },
  });

  async function handleChangeTab(tabName: string) {
    setFilterPlaceholder(
      tabName === "orders"
        ? "Buscar cobranças pontuais"
        : "Buscar assinaturas customizadas"
    );
    setActualTab(tabName);
  }

  async function handleDelete() {
    try {
      await handleDeleteCustomLink(userUuid.uuid);
      await getCustomLinkData();

      showToast({
        message: "Link customizado excluído com sucesso!",
        type: "success",
      });
      setDeleteModalState(!deleteModalState);
    } catch (error) {
      error?.response?.data?.errors.map((error) => {
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`,
        });
      });
    }
  }

  function handleDuplicateLink() {
    navigate(`/seja-pago/criar/cobranca-pontual?id=${userUuid.uuid}`);
    setDuplicateModalState(!duplicateModalState);
  }
  useEffect(() => {
    initialTabs.push({
      tab: "Cobranças pontuais",
      key: "orders",
      status: "",
    },
      {
        tab: "Cobranças recorrentes",
        key: "subscriptions",
        status: "",
      },)
    setTabs(initialTabs)
  }, [])

  useEffect(() => {
    if (clientButtonState === true) {
      const newResult = data?.content?.filter(
        ({ sellerClient }: any) => sellerClient?.name
      );
      if (!newResult) {
        setData({} as CustomLinkPaginator);
      } else {
        setData({
          ...data,
          content: newResult,
        });
      }
    } else {
      getCustomLinkData();
    }
  }, [clientButtonState]);

  // Ajusta a página quando o pageSize muda para evitar chamadas com páginas inexistentes
  useEffect(() => {
    // Quando o pageSize muda, resetar para página 0 (primeira página) para garantir recarregamento completo
    setCurrentPage(0);
  }, [pageSize]);

  useEffect(() => {
    setCurrentPage(0);
  }, [pageSize]);

  useEffect(() => {
    setCurrentPage(0);
  }, [pageSize]);

  useEffect(() => {
    getCustomLinkData();
  }, [actualTab, currentPage, pageSize]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        createMenuRef.current &&
        !createMenuRef.current.contains(event.target as Node)
      ) {
        setIsCreateMenuOpen(false);
      }
    };

    if (isCreateMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCreateMenuOpen]);

  return (
    <Box letterSpacing="tighter">
      <Alert
        closeButtonText={"Não"}
        confirmButtonText="Sim"
        isConfirmAlert={false}
        isOpen={deleteModalState}
        onConfirm={() => handleDelete()}
        onClose={() => setDeleteModalState(!deleteModalState)}
        title={`Tem certeza que deseja excluir esse link?`}
        messageBody="Excluí-lo desativará o link para futuras contratações."
        leastDestructiveRef={cancelRef}
      />

      <Alert
        closeButtonText={"Não"}
        confirmButtonText="Sim"
        isConfirmAlert={false}
        isOpen={duplicateModalState}
        onConfirm={() => handleDuplicateLink()}
        onClose={() => setDuplicateModalState(!duplicateModalState)}
        title={`Deseja duplicar esse link customizado?`}
        messageBody="O novo link replicará todas as informações do original,
        com exceção do cliente, que virá em branco."
        leastDestructiveRef={cancelRef}
      />
      <Box position="relative">
        <PageHeading
          onPrimaryAction={() => setIsCreateMenuOpen(!isCreateMenuOpen)}
          primaryActionLabel="Criar"
          title="Link de pagamento"
        />
        {isCreateMenuOpen && (
          <Box
            ref={createMenuRef}
            position="absolute"
            top="4.5rem"
            right="1.3rem"
            zIndex={100}
          >
            <DrawerList
              items={[
                {
                  label: "Link de Pagamento",
                  onClick: () => navigate("/seja-pago/criar/cobranca-pontual")
                }
              ]}
            />
          </Box>
        )}
      </Box>
      <Flex flexDir="column" marginTop="24px" gap="2rem" position="relative">

        <Tabs tabs={tabs.map(({ key, tab }) => ({
          key: key,
          label: tab,
          content: <></>
        }))} onChange={(key) => handleChangeTab(key)} currentKey={actualTab} />


        <Flex position="absolute" top="0.5rem" right="2rem">
          <Checkbox
            defaultChecked={clientButtonState}
            onChange={() => setClientButtonState(!clientButtonState)}
            label="Ver somente links dedicados a clientes"
          />

        </Flex>
        <Flex flexDirection="column" gap="1rem">
          <DynamicTable
            loading={false}
            columns={newColums}
            data={data?.content}
            onRowClick={(record) => navigate(`/seja-pago/editar/${record.uuid}`)}
            rowKey={(record) => record.uuid}
            locale={{ emptyText: "Sem dados de links customizados" }}
            pagination={{
              currentPage: currentPage + 1,
              pageSize: pageSize,
              onPageSizeChange: (size) => setPageSize(size),
              totalItems: data?.totalElements,
              totalPages: data?.totalPages,
              onPageChange: (currentPage) => setCurrentPage(currentPage - 1)
            }}
          />

        </Flex>
      </Flex>
    </Box>
  );
};

export default WithAuth(CustomLinks);
